import { useQuery } from '@tanstack/react-query';
import useSessionStore from '../state/session';
import { fetchTimeLaunchState } from '../data/scheduleTimeTracking';

/** Share the job clock's identity, authorization boundary and refresh lifecycle. */
export default function useTimeLaunchState() {
  const profileId = useSessionStore(s => s.profileId);
  const epoch = useSessionStore(s => s.principalEpoch);
  const preview = useSessionStore(s => s.isAccessPreview);
  const ready = useSessionStore(s => s.sessionReady);
  const roles = useSessionStore(s => s.accessRoleCodes);
  const security = useSessionStore(s => s.securityLevel);
  const authorizationKey = [profileId, epoch, preview, security, ...roles].join(':');
  const state = useQuery({ queryKey: ['schedule-time-launch', authorizationKey], queryFn: fetchTimeLaunchState,
    enabled: ready && Boolean(profileId) && !preview, staleTime: 15_000,
    refetchInterval: 30_000, refetchIntervalInBackground: false });
  return { state, authorizationKey, ready, preview, data: !preview && ready ? state.data : null };
}
